import { render, staticRenderFns } from "./CardSlider.vue?vue&type=template&id=da0f2c6a"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports